import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

const UsdNumber = Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
const AcreNumber = Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 1 });

/** Acre proposal product summary header. */
export const ProductSummaryHeader = (props: {
	acres: number;
	totalBags: number;
	seedsPerAcre: number;
	targetYield?: number;

	allowPricing: boolean;
	costPerAcre: number;
	totalCost: number;
}) => 
{
	return (
		<StyledSummaryRow className='ProductSummaryRow'>
			<div className='FixedArea'>
			Plan Total:
			</div>
			<div className='FlexArea'>
				{
					props.targetYield !== undefined &&
						<div className='HybridYieldTarget'>
							{props.targetYield} Target Yield
						</div>
				}
				{
					props.allowPricing && 
						<div className='HybridCostPerAcre'>
							{props.costPerAcre ? <>{UsdNumber.format(props.costPerAcre)} Cost/Ac</> : <>---</>}
						</div>
				}
				<div className='HybridCost'>
					{AcreNumber.format(props.acres)} Acres
				</div>
				<div className='HybridQuantity'>
					{props.totalBags} Bags
				</div>
				<div className='HybridSeedRate'>
					Seeds/Ac: {props.seedsPerAcre ?? ''}
				</div>
				{props.allowPricing &&
					<div className='HybridTotalPrice'>
						Total: {UsdNumber.format(props.totalCost)}
					</div>
				}
			</div>
		</StyledSummaryRow>
	);
};

const StyledSummaryRow = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	font-size: ${themeGet('fontSizes.extraSmall')};
	background-color: ${themeGet('colors.primary')};
	color: ${themeGet('colors.white')};
	margin-top: 10px;
	margin-bottom: 10px;
	border-radius: 6px 6px 6px 6px;
	height: 40px;
	min-height: 40px;
	
	.FixedArea {
		width: 200px;
		margin-left: 10px;
		align-items: center;
    	display: flex;
    	justify-content: center;
	}

	.FlexArea {
		display: flex;
		flex-direction: row;
		flex-grow: 1;
		align-items: center;
		flex-wrap: wrap;

		>div {
			flex-grow: 0;
			flex-shrink: 0;
			width: 120px;
			flex-grow: 1;
			display:flex;
			flex-direction: row;
			justify-content: center;
		}
	}
`;